export default [
    {
        id: 11,
        img: "https://dkstatics-public.digikala.com/digikala-products/34abacc5010c4cd33c505c53e62abb5cdd7ff141_1694165312.jpg?x-oss-process=image/resize,m_lfit,h_800,w_800/format,webp/quality,q_90",
        name: "چراغ",
        category: "دکور",
        info: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی و فرهنگ پیشرو در زبان فارسی ایجاد کرد. ",
        colors: ['red','blue'], 
      featured: true,
        price: 11000,
       amount:1,
        freeDelivery: true,
    },
    {
        id: 12,
        img: "https://dkstatics-public.digikala.com/digikala-products/7e0c845766ffa7da910b8dc381778a2ceb991fd5_1609009595.jpg?x-oss-process=image/resize,m_lfit,h_800,w_800/format,webp/quality,q_90",
        name: "میز کافه",
        category: "میز",
        info: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی و فرهنگ پیشرو در زبان فارسی ایجاد کرد. ",
        colors: ['brown', 'black'],
        featured: true,
        price: 12000,
       amount:1,
        freeDelivery: false,
    },
    {
        id: 13,
        img: "https://dkstatics-public.digikala.com/digikala-products/98f2e196da9438bcbc6440e1eaa5fa71f8846eb5_1636454903.jpg?x-oss-process=image/resize,m_lfit,h_800,w_800/format,webp/quality,q_90",
        name: "تخت",
        category: "تخت",
        info: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی و فرهنگ پیشرو در زبان فارسی ایجاد کرد. ",
        colors: ['red'],
      featured: true,
        price: 13000,
       amount:1,
        freeDelivery: true
    },
    {
        id: 14,
        img: "https://dkstatics-public.digikala.com/digikala-products/165d52eff8f735cab906182b3a1c56b66ef18f31_1694114544.jpg?x-oss-process=image/resize,m_lfit,h_800,w_800/format,webp/quality,q_90",
        name: "شمع",
        category: "دکور",
        info: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی و فرهنگ پیشرو در زبان فارسی ایجاد کرد. ",
     
        colors: ['red','blue'],
        featured: false,
        price: 14000,
       amount:1,
        freeDelivery: false
    },
    {
        id: 15,
        img: "https://dkstatics-public.digikala.com/digikala-products/b2d45f51b5067e20fa3b859f46f1dbcf3f31c366_1612181119.jpg?x-oss-process=image/resize,m_lfit,h_800,w_800/format,webp/quality,q_90",
        name: "گلدان",
        categor: "دکور",
        info: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی و فرهنگ پیشرو در زبان فارسی ایجاد کرد. ", 
        colors: ['red','blue'],
        featured: false,
        price: 15000,
       amount:1,
        freeDelivery: false
    },
    {
        id:16,
        img: "https://dkstatics-public.digikala.com/digikala-products/2669246.jpg?x-oss-process=image/resize,m_lfit,h_800,w_800/format,webp/quality,q_90",
        name: "کره ی شیشه ای",
        category: "دکور",
        info: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی و فرهنگ پیشرو در زبان فارسی ایجاد کرد. ",
       
        colors: ['yellow', 'pink'],
        featured: false,
        price: 16000,
       amount:1,
        freeDelivery: false
    },
    {
        id: 17,
        img: "https://dkstatics-public.digikala.com/digikala-products/a30505e12bb61518e25fb88e04501dfbdf3edebc_1627330579.jpg?x-oss-process=image/resize,m_lfit,h_800,w_800/format,webp/quality,q_90",
        name: "میز گرد",
        category: "میز",
        info: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی و فرهنگ پیشرو در زبان فارسی ایجاد کرد. ",
       
        colors: ['red','blue'],
        featured: false,
        price: 17000,
       amount:1,
        freeDelivery: false
    },
    {
        id: 18,
        img: "https://dkstatics-public.digikala.com/digikala-products/177115289498dff2acb9d837ca5c1b1330a475f8_1687004328.jpg?x-oss-process=image/resize,m_lfit,h_800,w_800/format,webp/quality,q_90",
        name: "میز مربعی",
        category: "میز",
        info: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی و فرهنگ پیشرو در زبان فارسی ایجاد کرد. ",
       
        colors: ['red','blue'],
        featured: false,
        price: 18000,
       amount:1,
        freeDelivery: false
    },
    {
        id: 19,
        img: "https://dkstatics-public.digikala.com/digikala-products/492f765deb08b1c65bb6637b360997ddb439fcaf_1686302334.jpg?x-oss-process=image/resize,m_lfit,h_800,w_800/format,webp/quality,q_90",
        name: "دکوری مدل wednesday",
        category: "دکور",
        info: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی و فرهنگ پیشرو در زبان فارسی ایجاد کرد. ",
       
        colors: ['red','blue'],
        featured: false,
        price: 11500,
       amount:1,
        freeDelivery: true
    },
    {
        id: 20,
        img: "https://dkstatics-public.digikala.com/digikala-products/7f86a24ef44a0b1611f4de0171dade5abd11a7fc_1632756001.jpg?x-oss-process=image/resize,m_lfit,h_800,w_800/format,webp/quality,q_90",
        name: "میز کامپیوتر",
        category: "میز",
        info: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی و فرهنگ پیشرو در زبان فارسی ایجاد کرد. ",
       
        colors: ['brown', 'white'],
        featured: false,
        price: 12000,
       amount:1,
        freeDelivery: false
    },
    {
        id: 21,
        img: "https://dkstatics-public.digikala.com/digikala-products/c1733ebd619fbda6799fdd3983ab7d96f4f3f365_1628140067.jpg?x-oss-process=image/resize,m_lfit,h_800,w_800/format,webp/quality,q_90",
        name: "تخت یکنفره",
        category: "تخت",
        info: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی و فرهنگ پیشرو در زبان فارسی ایجاد کرد. ",
       
        colors: ['red'],
      featured: false,
        price: 13700,
       amount:1,
        freeDelivery: false
    },
    {
        id: 22,
        img: "https://dkstatics-public.digikala.com/digikala-products/539507e5fc4a619900bc8a967cf2af8247c414ba_1607152143.jpg?x-oss-process=image/resize,m_lfit,h_800,w_800/format,webp/quality,q_90",
        name: "دکوری کادووین طرح پیانو",
        category: "دکور",
        info: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی و فرهنگ پیشرو در زبان فارسی ایجاد کرد. ",
       
        colors: ['red','blue'],
        featured: false,
        price: 14000,
       amount:1,
        freeDelivery: false
    },
    {
        id: 23,
        img: "https://dkstatics-public.digikala.com/digikala-products/63977dfb9ea6d6538255f6d92aeba80e9b2eeae3_1627971452.jpg?x-oss-process=image/resize,m_lfit,h_800,w_800/format,webp/quality,q_90",
        name: "دکوری کشتی بادبانی",
        category: "دکور",
        info: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی و فرهنگ پیشرو در زبان فارسی ایجاد کرد. ",
       
        colors: ['red','blue'],
        featured: false,
        price: 15500,
       amount:1,
        freeDelivery: false
    },
    {
        id: 24,
        img: "https://dkstatics-public.digikala.com/digikala-products/647e2e205351dbbe0f353818863488445af1190e_1611703898.jpg?x-oss-process=image/resize,m_lfit,h_800,w_800/format,webp/quality,q_90",
        name: "دکوری شبشه ی آرزو",
        category: "دکور",
        info: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی و فرهنگ پیشرو در زبان فارسی ایجاد کرد. ",
       
        colors: ['yellow', 'pink'],
        featured: false,
        price: 23000,
       amount:1,
        freeDelivery: false
    },
    {
        id: 25,
        img: "https://dkstatics-public.digikala.com/digikala-products/89f1d5251dcfd61217376014eda669d73eb17b60_1686312359.jpg?x-oss-process=image/resize,m_lfit,h_800,w_800/format,webp/quality,q_90",
        name: "میز اداری",
        category: "میز",
        info: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی و فرهنگ پیشرو در زبان فارسی ایجاد کرد. ",
        colors: ['red','blue'],
        featured: false,
        price: 15800,
       amount:1,
        freeDelivery: true
    },
    {
        id: 26,
        img: "https://dkstatics-public.digikala.com/digikala-products/96d2690a4c39efd9eff74263e7c8a22f75008df4_1686297913.jpg?x-oss-process=image/resize,m_lfit,h_800,w_800/format,webp/quality,q_90",
        name: "میز ناهار خوری دیزم",
        category: "میز",
        info: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی و فرهنگ پیشرو در زبان فارسی ایجاد کرد. ",
       
        colors: ['red','blue'],
        featured: false,
        price: 17300,
       amount:1,
        freeDelivery: false
    },
    {
        id: 27,
        img: "https://dkstatics-public.digikala.com/digikala-products/a6ee181a25315815dd29686892e3c731a6a1d534_1674394130.jpg?x-oss-process=image/resize,m_lfit,h_800,w_800/format,webp/quality,q_90",
        name: "آونگ دیزم",
        category: "دکور",
        info: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی و فرهنگ پیشرو در زبان فارسی ایجاد کرد. ",
       
        colors: ['red','blue'],
        featured: false,
        price: 11900,
       amount:1,
        freeDelivery: false
    },
    {
        id: 28,
        img: "https://dkstatics-public.digikala.com/digikala-products/1d1e911d704030e48dbedee8152e75b48ce81317_1612457202.jpg?x-oss-process=image/resize,m_lfit,h_800,w_800/format,webp/quality,q_90",
        name: "میز عسلی",
        category: "دکور",
        info: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی و فرهنگ پیشرو در زبان فارسی ایجاد کرد. ",
       
        colors: ['brown', 'white'],
        featured: false,
        price: 12240,
       amount:1,
        freeDelivery: false
    },
    {
        id: 29,
        img: "https://dkstatics-public.digikala.com/digikala-products/a2789ce214e0f54f0e0a815e3a89e73c3d860837_1625071751.jpg?x-oss-process=image/resize,m_lfit,h_800,w_800/format,webp/quality,q_90",
        name: " تخت دونفره مدل لوزی دوطبفه",
        category: "تخت",
        info: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی و فرهنگ پیشرو در زبان فارسی ایجاد کرد. ",
       
        colors: ['red'],
      featured: false,
        price: 14500,
       amount:1,
        freeDelivery: false
    },
    {
        id: 30,
        img: "https://dkstatics-public.digikala.com/digikala-products/165d52eff8f735cab906182b3a1c56b66ef18f31_1694114544.jpg?x-oss-process=image/resize,m_lfit,h_800,w_800/format,webp/quality,q_90",
        name: "شمع",
        category: "دکور",
        info: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی و فرهنگ پیشرو در زبان فارسی ایجاد کرد. ",
       
        colors: ['red','blue'],
        featured: false,
        price: 14000,
       amount:1,
        freeDelivery: false
    },
    {
        id: 31,
        img: "https://dkstatics-public.digikala.com/digikala-products/f7fa2c4fe60d43a6e9e58d8abce685086c7c0c05_1676931889.jpg?x-oss-process=image/resize,m_lfit,h_800,w_800/format,webp/quality,q_90",
        name: "دکوری توپ فوتبال",
        category: "دکور",
        info: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی و فرهنگ پیشرو در زبان فارسی ایجاد کرد. ",
       
        colors: ['red','blue'],
        featured: false,
        price: 15900,
       amount:1,
        freeDelivery: true
    },
    {
        id: 32,
        img: "https://dkstatics-public.digikala.com/digikala-products/df69f81c5966bc0cc7d36d5ec1326a780c1fed34_1641740198.jpg?x-oss-process=image/resize,m_lfit,h_800,w_800/format,webp/quality,q_90",
        name: "گلدان دکو سیتی",
        category: "دکور",
        info: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی و فرهنگ پیشرو در زبان فارسی ایجاد کرد. ",
       
        colors: ['yellow', 'pink'],
        featured: false,
        price: 16000,
       amount:1,
        freeDelivery: false
    },
    {
        id: 33,
        img: "https://dkstatics-public.digikala.com/digikala-products/ef13d0d1d6c4f0c33b95148722a265717ea61d48_1661599655.jpg?x-oss-process=image/resize,m_lfit,h_800,w_800/quality,q_90",
        name: "میز نحریر",
        category: "میز",
        info: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی و فرهنگ پیشرو در زبان فارسی ایجاد کرد. ",
       
        colors: ['red','blue'],
        featured: false,
        price: 18400,
       amount:1,
        freeDelivery: false
    },
    {
        id: 34,
        img: "https://dkstatics-public.digikala.com/digikala-products/83e58d84a143d2511bf7ab007fcbb3508bea8eb5_1641292170.jpg?x-oss-process=image/resize,m_lfit,h_800,w_800/format,webp/quality,q_90",
        name: "میز اداری سفید",
        category: "میز",
        info: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی و فرهنگ پیشرو در زبان فارسی ایجاد کرد. ",
       
        colors: ['red','blue'],
        featured: false,
        price: 14600,
       amount:1,
        freeDelivery: true
    }
  ];
  
  